import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { tabsInjectionKey as P } from "./interface.js";
import { tabPaneProps as y } from "./TabPane.js";
import T from "../../_internal/icon/src/Icon.js";
import $ from "../../_internal/icons/Add.js";
import { render as R } from "../../_utils/vue/render.js";
import B from "../../_internal/close/src/Close.js";
import { omit as _ } from "../../_utils/vue/omit.js";
import { defineComponent as A, inject as x, computed as j, h as t, mergeProps as S, Fragment as k } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const I = Object.assign({
  internalLeftPadded: Boolean,
  internalAddable: Boolean,
  internalCreatedByPane: Boolean
}, _(y, ["displayDirective"])), z = A({
  __TAB__: !0,
  inheritAttrs: !1,
  name: "Tab",
  props: I,
  setup(a) {
    const {
      mergedClsPrefixRef: e,
      valueRef: l,
      typeRef: n,
      closableRef: d,
      tabStyleRef: f,
      addTabStyleRef: c,
      tabClassRef: o,
      addTabClassRef: b,
      tabChangeIdRef: r,
      onBeforeLeaveRef: i,
      triggerRef: h,
      handleAdd: v,
      activateTab: u,
      handleClose: C
    } = x(P);
    return {
      trigger: h,
      mergedClosable: j(() => {
        if (a.internalAddable)
          return !1;
        const {
          closable: s
        } = a;
        return s === void 0 ? d.value : s;
      }),
      style: f,
      addStyle: c,
      tabClass: o,
      addTabClass: b,
      clsPrefix: e,
      value: l,
      type: n,
      handleClose(s) {
        s.stopPropagation(), !a.disabled && C(a.name);
      },
      activateTab() {
        if (a.disabled)
          return;
        if (a.internalAddable) {
          v();
          return;
        }
        const {
          name: s
        } = a, p = ++r.id;
        if (s !== l.value) {
          const {
            value: m
          } = i;
          m ? Promise.resolve(m(a.name, l.value)).then((g) => {
            g && r.id === p && u(s);
          }) : u(s);
        }
      }
    };
  },
  render() {
    const {
      internalAddable: a,
      clsPrefix: e,
      name: l,
      disabled: n,
      label: d,
      tab: f,
      value: c,
      mergedClosable: o,
      trigger: b,
      $slots: {
        default: r
      }
    } = this, i = d != null ? d : f;
    return t("div", {
      class: `${e}-tabs-tab-wrapper`
    }, this.internalLeftPadded ? t("div", {
      class: `${e}-tabs-tab-pad`
    }) : null, t("div", Object.assign({
      key: l,
      "data-name": l,
      "data-disabled": n ? !0 : void 0
    }, S({
      class: [`${e}-tabs-tab`, c === l && `${e}-tabs-tab--active`, n && `${e}-tabs-tab--disabled`, o && `${e}-tabs-tab--closable`, a && `${e}-tabs-tab--addable`, a ? this.addTabClass : this.tabClass],
      onClick: b === "click" ? this.activateTab : void 0,
      onMouseenter: b === "hover" ? this.activateTab : void 0,
      style: a ? this.addStyle : this.style
    }, this.internalCreatedByPane ? this.tabProps || {} : this.$attrs)), t("span", {
      class: `${e}-tabs-tab__label`
    }, a ? t(k, null, t("div", {
      class: `${e}-tabs-tab__height-placeholder`
    }, " "), t(T, {
      clsPrefix: e
    }, {
      default: () => t($, null)
    })) : r ? r() : typeof i == "object" ? i : R(i != null ? i : l)), o && this.type === "card" ? t(B, {
      clsPrefix: e,
      class: `${e}-tabs-tab__close`,
      onClick: this.handleClose,
      disabled: n
    }) : null));
  }
});
export {
  z as default,
  I as tabProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tabs/src/Tab.js
// module id = 1744
// module chunks = 67